
















import { IStoreLink } from '@/store/modules/storelinks'
import Axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    ResultItem: require('./ResultItem').default
  }
})
export default class Results extends Vue {
  searching: boolean = false
  storeLinks: IStoreLink[] = []

  get links(): string[] {
    return this.$store.state.storelinks.links
  }

  get combos(): string[][] {
    return this.$store.state.storelinks.combos
  }

  get total(): number {
    return this.links.length || this.combos.length
  }

  get remaining(): number {
    return this.total - this.storeLinks.length
  }

  get progress(): number {
    if (!this.searching) return 100

    return 100 / (this.total / this.storeLinks.length)
  }

  async fetch(followupRetry: boolean, link: string | null, combo?: string[]) {
    const params: any = {}

    if (link) params.link = link
    else if (combo) params.combo = combo

    const { data }: { data: IStoreLink[] } = await Axios.post('/storelink/search', params)

    if (data.length === 1) { // Returns array of 1
      if (followupRetry) {
        data[0].isLoading = !data[0].fromCache

        this.storeLinks.push(data[0])
      } else {
        const i = this.storeLinks.findIndex(x => x._id && x._id === data[0]._id)

        this.storeLinks.splice(i, 1, data[0])
      }

      if (followupRetry && !data[0].fromCache) { // Try again soon after because some external sites can be very slow
        setTimeout(() => {
          if (!(this as any)._isDestroyed) {
            this.fetch(false, link, combo).catch(console.error)
          }
        }, 10000)
      }
    }
  }

  async search() {
    try {
      this.searching = true

      if (this.$store.state.auth.isDemoUser) {
        const axiosDemoClient = Axios.create({
          baseURL: '/'
        })

        const { data } = await axiosDemoClient.get('/demo/storelinks.json')

        this.storeLinks = data
      } else {
        if (this.$store.state.storelinks.cached.length > 0) {
          this.storeLinks = this.$store.state.storelinks.cached
        } else {
          if (this.links.length > 0) {
            for (const link of this.links) {
              await this.fetch(true, link)
            }
          } else if (this.combos.length > 0) {
            for (const combo of this.combos) {
              await this.fetch(true, null, combo)
            }
          }
        }
      }
    } catch (error) {
      await this.$router.replace({
        name: 'store links'
      })
    } finally {
      setTimeout(() => {
        this.searching = false
      }, 1000)
    }
  }

  async created() {
    if (!this.$store.getters['storelinks/valid']) {
      await this.$router.replace({
        name: 'store links'
      })

      return
    }

    await this.search()
  }
}
